import vInternetExplorer from "./v-internet-explorer.vue";

export default Vue => {
  Vue.component("v-internet-explorer", vInternetExplorer);
};
